export default function fancyBox(){
    if(document.querySelector("[data-fancybox='maps']")){
        Fancybox.bind("[data-fancybox='maps']", {
            Thumbs: {
                type: "classic",
            },
        });
    }
}